export default {
  flatFee: 1,
  commission: 2,
  flatFeeAndCommission: 3,
}
